export const COOKIE_NAME_KEY_AUTH = 'key';
export const COOKIE_NAME_LANGUAGE = 'NEXT_LOCALE';
export const COOKIE_NAME_IS_BOT = 'is-bot';
export const COOKIE_NAME_PROFILE_CACHE = 'profile-cache';
export const COOKIE_AB_TESTS = 'ab_experiments';
